import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {HttpClient} from '@angular/common/http';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {forbiddenNameValidator} from '@app/app/dashboard/forms/park-schedule-form/park-schedule-form.component';

@Component({
  selector: 'toggle-led-dialog',
  templateUrl: 'toggle.led.dialog.html',
})

export class ToggleLedDialogComponent {
  controllerId = null;
  parkId = null;
  url = null;
  provisioningInProgress = false;
  files = [];
  public toggleLedForm: FormGroup;


  constructor(public dialogRef: MatDialogRef<ToggleLedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              private http: HttpClient) {
    this.controllerId = data.controllerId;
    this.parkId = data.parkId;
    this.url = data.url;

    this.toggleLedForm = new FormGroup({
      leds: new FormGroup({
        1: new FormControl(),
        2: new FormControl(),
        3: new FormControl(),
        4: new FormControl(),
        5: new FormControl(),
        6: new FormControl(),
        7: new FormControl(),
      }),
    });
  }

  toggleLed({value, valid}) {
    const leds = value.leds;

    const isOn = [];

    Object.keys(leds).forEach((index) => {
      if (leds[index]) {
        isOn.push(index);
      }
    });

    this.provisioningInProgress = true;

    this.http.post(this.url, {data: isOn.join(',')}).subscribe((res: any) => {
      this.provisioningInProgress = false;
    }, () => {
      this.provisioningInProgress = false;
    });
  }

  private completeProvisioning() {
    this.provisioningInProgress = false;
    this.dialogRef.disableClose = false;
  }

  formatSize(file: { size: number }) {
    if (file.size < 1000) {
      return file.size + 'B';
    } else if (file.size < 1000000) {
      return (file.size / 1000).toFixed(2) + 'kB';
    } else {
      return (file.size / 1000000).toFixed(2) + 'MB';
    }
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

  startProvisioning() {
    this.provisioningInProgress = true;
    this.dialogRef.disableClose = true;

    const body = {
      files: this.files,
    };

    this.http.post(this.url, body).subscribe(() => {
      this.completeProvisioning();

      this.dialogRef.close({success: true, message: 'Provisioning started. This may take a few minutes'});
    }, (err) => {
      this.completeProvisioning();
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/controller/toggle.led.dialog.component.ts